module.exports = __webpack_public_path__ + "56d19e5de4f8a4d6bf76772f3f53c230.pdf";